import { render } from "./ColorSelectorDrawer.vue?vue&type=template&id=09308505&scoped=true"
import script from "./ColorSelectorDrawer.vue?vue&type=script&lang=js"
export * from "./ColorSelectorDrawer.vue?vue&type=script&lang=js"

import "./ColorSelectorDrawer.vue?vue&type=style&index=0&id=09308505&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09308505"]])

export default __exports__